import {Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {OwnerService} from "../services/owner.service";
import {GlobalDataService} from "../../housekeeping/services/global-data.service";
import * as XLSX from 'xlsx';
import * as Papa from 'papaparse';
import {ExceldownloadService} from "../../housekeeping/services/exceldownload.service";
import {AdminService} from "../../admin/services/admin.service";
import * as moment from "moment";
import {OwnerCrudService} from "../services/owner-crud.service";


@Component({
  selector: 'app-detail',
  templateUrl: '../views/owner-bulk.component.html',
  styleUrls: ['../css/owner-bulk.component.css']
})
export class OwnerBulkComponent implements OnInit {
  public userTZ = '';
  public ownerId: any;
  public data: any;
  public vins: any;
  public dbRecords: any;
  public headers: any = ["STATUS", "VIN", "FIRST NAME", "LAST NAME", "EMAIL", "MOBILE PHONE", "HOME PHONE", "DEALER CODE"];
  public step3: boolean = false;
  public finish: boolean = false;
  public fileLoaded: boolean = false;
  public fileLengthError: boolean = false;
  public fileFormatError: boolean = false;
  public fileName:any = "";
  public file:any;
  public validated: any = 0;
  public userId :any;
  public dealers: any[] = [];
  @ViewChild("fileDropRef") fileDropEl: ElementRef;
  files: any[] = [];

  constructor(public _router: Router, public _adminServcie: AdminService, public activeroute: ActivatedRoute, public _ownerCrudService: OwnerCrudService, public _ownerService: OwnerService, public _dataService: GlobalDataService, private _exceldownloadService: ExceldownloadService) {
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.userTZ = this._dataService.USER_TZ;
    this.userId = Number(sessionStorage.getItem('userId'));
    this.activeroute.params.subscribe(
      params => {
        if (Object.keys(params).length != 0) {
          this.ownerId = params.id;
        }
      });
    this._adminServcie.getAdminDetails(this.userId, (result) => {
      for (let dealer of result.dealers) {
        this.dealers.push(dealer.superDealerCode);
        this.dealers.push(dealer.globalCode);
      }
      ;
    })

  }

  checkMissing(obj, field) {
    let missing = false;
    let reasons = obj[9];
    if (field == 1 && obj.length>9 && reasons.indexOf("VIN not found in the DB or not available to your dealership") > -1) {
      missing = true;
    }
    switch (field) {
      case 3:
        if (obj[3].length == 0) {
          missing = true;
        }
        break;
      case 4:
        if (obj[4].length == 0 || !this.isValidEmail(obj[4])) {
          missing = true;
        }
        break;
      case 1:
        if (obj[1].length == 0) {
          missing = true;
        }
        if (obj[1].length != 17) {
          missing = true;
        }
        break;
      case 5:
        if (obj[5].length == 0 && obj[6].length == 0) {
          missing = true;
        } else {
          if (obj[5].length != 0 && !this.isValidPhone(obj[5])) {
            missing = true;
          }
        }
        break;
      case 6:
        if (obj[5].length == 0 && obj[6].length == 0) {
          missing = true;
        } else {
          if (obj[6].length != 0 && !this.isValidPhone(obj[6])) {

            missing = true;

          }
        }
        break;
      case 7:
        if (obj[7].length != 0) {
          if (!this.checkDealerCode(obj[7])) {
            missing = true;
          }
        }
        break;
      case 8:
        if (!this.isValidDate(obj[8])) {
          missing = true;
        }
    }
    return missing
  }

  /**
   * on file drop handler
   */
  onFileDropped(files: Array<any>) {
    this.fileLengthError=false;
    this.fileFormatError=false;
    this.fileLoaded=false;
    const file = files[0];
    if (!this.checkFileFormat(file)) {
      this._dataService.trackUserClick(this.userId,'BulkWrongFormat');
      this.fileFormatError=true;
      return
    }
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.processFileToWebData(e);
      if (this.data.length > 301) {
        this._dataService.trackUserClick(this.userId,'BulkMoreThan300Records')
        this.fileLengthError=true;

        this.data = [];
        return;
      }
    };
    this._dataService.trackUserClick(this.userId,'BulkFileUploaded')
    reader.readAsArrayBuffer(file);
    this.fileLengthError=false;
    this.fileFormatError=false;
    this.fileName=file.name;
    this.data = [];
    this.file=file;
    this.fileLoaded=true;


  }
  loadStage3(){
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.processFileToWebData(e);
      this.prepareForTable();
      if (this.data.length > 301) {
        this.data = [];
        return;
      }
    };
    reader.readAsArrayBuffer(this.file);
    this.step3 = true;
    window.scrollTo(0, 0);
  }

  getFileDate(){
    const date = new Date();
    return "" + (date.getMonth()+1)+"_"+date.getDate()+"_"+date.getFullYear();
  }
  extractVinsFromExcelFile() {
    var vins = [];
    for (let row of this.data) {
      vins.push(row[1]);
    }
    return vins;
  }

  /**
   * convert uploaded file to data
   * @param e
   */
  processFileToWebData(e) {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, {type: 'array'});
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const csv = XLSX.utils.sheet_to_csv(worksheet);
    const excelData = Papa.parse(csv).data;
    const ta = excelData;
    var d=[];
    for(var i=0;i<ta.length;i++){
      var entry=ta[i];
      var missing=0;
      for(var x=0;x<entry.length;x++){
        if(entry[x].length==0){
          missing++;
        }
      }

      if(missing<6 && entry.length>6){
        d.push(entry);
      }
    }
    this.data=d;
  }

  checkDealerCode(code) {
    let found = false;
    for (let dcode of this.dealers) {
      if (dcode == code) {
        found = true;
      }
    }
    return found;
  }

  finishWizard() {
    if (this.data.length>0 && (this.validated) != this.data.length) {
      alert("You have Errors in you're file!")
      return
    }
    this.step3 = false;
    let prepareData=[];
    for(var i=0;i<this.data.length;i++){
      var entry =this.data[i];
      var d={};
      d['status']=entry[0];
      d['vin']=entry[1];
      d['firstName']=entry[2];
      d['lastName']=entry[3];
      d['email']=entry[4];
      d['mobilePhone']=entry[5];
      d['homePhone']=entry[6];
      d['dealerCode']=entry[7];
      d['reasons']=entry[9];
      prepareData.push(d);
    }
    this._ownerCrudService.saveBulkOwner(prepareData, this.userId, () => {console.log("done");});
    this.finish = true;
  }
  filterHtmlData(v){
    let val=v.replaceAll("<p style='font-size: 12px;color: white;line-height: 12px'>","").replaceAll("</p>","")
    return val;
  }
findDuplicates(arr){
  let countMap = {};
  arr.forEach(function(str) {
    countMap[str] = (countMap[str] || 0) + 1;
  });
  let duplicatesArray = [];
  for (let str in countMap) {
    if (countMap[str] > 1) {
      duplicatesArray.push(str);
    }
  }
  return duplicatesArray;
}
findByVin(arr,vin){
    for(let i=0;i<arr.length;i++){
    if(arr[i].vin==vin){
      return arr[i];
    }
  }
  return null;
}
  checkVins(callback) {
    let dbVins = [];
    let duplicates=this.findDuplicates(this.extractVinsFromExcelFile());
    this._ownerService.checkVins(this.extractVinsFromExcelFile(), (result) => {
      for(let i=0;i<result.length;i++){
        let record=result[i];
        if(record.purchase_date){
          record.purchase_date=moment(record.purchase_date).format("YYYY-MM-DD");
        }
      }
      this.dbRecords= result;
      for (let i = 0; i < result.length; i++) {
        let vin = result[i].vin;
        dbVins.push(vin);
      }

      for (let i = 0; i < this.data.length; i++) {
        let el = this.data[i];
        let found = false;
        for (let vin of dbVins) {
          if (vin == el[1]) {
            found = true;
            let foundRecord=this.findByVin(result,vin);
              el[8] = foundRecord.purchase_date
              if (el[0] != 2) {
                el[0] = 1;
                el[9] = "";
            }
          }
        }
        if (!found) {
          el[0] = 2;
          el[9] = "<p style='font-size: 12px;color: white;line-height: 12px'>VIN not found in the DB or not available to your dealership</p>";
        }

        for(let str in duplicates){

          if(el[1] == duplicates[str]){

            el[0] = 2;
            el[9] = "<p style='font-size: 12px;color: white;line-height: 12px'>The same VIN was found multiple times in the file. Since owner information can only be updated once per day for each VIN, please update the file to include only one instance of each VIN</p>";
          }
        }

        this.data[i] = el;

      }
      callback(this.data);
    });
  }

  prepareForTable() {
    var formattedData = [];
    for (var el = 1; el < this.data.length; el++) {
      var newEl = [0].concat(this.data[el]);
      formattedData.push(newEl);
    }
    this.data = formattedData;
    this.processDataForErrors();
  }

  isValidDate(d) {
    if (this.containsOnlyNumbers(d)) {
      return false;
    }
    return this.getValidatedDate(d);
  }

  checkDate(d) {
    // Auto-detect the date format
    let detectedFormat = moment(d, moment.ISO_8601, true).format();
    if (detectedFormat == "Invalid date" && d && d.indexOf("/") > 0) {
      let day = d.split("/")[0];
      let month = d.split("/")[1];
      let year = d.split("/")[2];
      if (day.length == 1) {
        day = "0" + day;
      }
      if (month.length == 1) {
        month = "0" + month;
      }
      if (year.length == 2) {
        year = "20" + year;
      }
      return day+"/"+month+"/"+year;
    }

// Check if the date is valid
    const isValidDate = moment(d, detectedFormat, true).isValid();

    return isValidDate;
  }

  formatDate(d){
    if(d && d.indexOf("/")!=-1){
      return this.checkDate(d);
    }else{
      return d;
    }
  }
  getValidatedDate(d) {

    if (moment(d, "MM/DD/YYYY", true).isValid()) {
      return true;
    }
    if (moment(d, "DD/MM/YYYY", true).isValid()) {
      return true;
    }
    if (moment(d, "YYYY/MM/DD", true).isValid()) {
      return true;
    }
    if (moment(d, "YYYY/DD/MM", true).isValid()) {
      return true;
    }
    if (moment(d, "MM-DD-YYYY", true).isValid()) {
      return true;
    }
    if (moment(d, "DD-MM-YYYY", true).isValid()) {
      return true;
    }
    if (moment(d, "YYYY-MM-DD", true).isValid()) {
      return true;
    }
    if (moment(d, "YYYY-DD-MM", true).isValid()) {
      return true;
    }
    if (moment(d, "MM.DD.YYYY", true).isValid()) {
      return true;
    }
    if (moment(d, "DD.MM.YYYY", true).isValid()) {
      return true;
    }
    if (moment(d, "YYYY.MM.DD", true).isValid()) {
      return true;
    }
    if (moment(d, "YYYY.DD.MM", true).isValid()) {
      return true;
    }


    return this.checkDate(d);

  }

  containsOnlyNumbers(str) {
    return /^[0-9]+$/.test(str);
  }

  isValidEmail(e) {
    const emailRegex = /^[a-zA-Z0-9]+[\w.-]*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
    return emailRegex.test(e);
    /*
    if (e.indexOf("@") > 0) {
      let chunks = e.split("@");
      if (chunks[0].length < 3 || chunks[1].length < 3) {
        return false
      } else {
        return true;
      }
    }*/
  }

  isValidPhone(p) {
    let corr = false;
    const regex10 = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    const regex7 = /^\(?([0-9]{3})\)?[-. ]?([0-9]{4})$/;
    const phoneRegex = /^(\+\d{1,4})?\s?(\(\d{1,4}\)|\d{1,4})\s?[\s.-]?\d{1,4}[\s.-]?\d{1,4}([\s.-]?\d{1,4})?$/;
    if (regex10.test(p)) {
      corr = true
    }
    if (regex7.test(p)) {
      corr = true
    }
    if (phoneRegex.test(p)) {
      corr = true
    }
    return corr
  }

  getValidatedNumber(fdata) {
    let count = 0;
    for (let d of fdata) {
      if (d[0] == 1) {
        count++;
      }
    }
    this.validated = count;
  }

  exportProcessedData() {
    var json = [];
    for (let entry of this.data) {
      var formatedEntry = {
        vin: entry[1],
        first_name: entry[2],
        last_name: entry[3],
        email: entry[4],
        mphone: entry[5],
        hphone: entry[6],
        dealer: entry[7],
        reason: this.filterHtmlData(entry[9])
      };
      json.push(formatedEntry);
    }
    this._exceldownloadService.ExportRejectFile(json);
  }

  processDataForErrors() {
    var formattedData = [];
     this.checkVins( (result) => {
       for (var el = 0; el < this.data.length; el++) {
         let curr = this.data[el];

         if (curr.length > 7) {
           let errors = "";
           if (curr[3].length == 0) {
             errors += "<p style='font-size: 12px;color: white;line-height: 12px'>Last name cannot be empty. </p> ";
             curr[0] = 2;
           }
           if (curr[4].length == 0) {
             errors += "<p style='font-size: 12px;color: white;line-height: 12px'>Email address cannot be empty. </p>";
             curr[0] = 2;
           }
           if (!this.isValidEmail(curr[4]) && curr[4].length>0) {
             errors += "<p style='font-size: 12px;color: white;line-height: 12px'>Email address format is incorrect. </p>";
             curr[0] = 2;
           }
           if (curr[1].length == 0) {
             errors += "<p style='font-size: 12px;color: white;line-height: 12px'>VIN cannot be empty.</p> ";
             curr[0] = 2;
           }
           if (curr[1].length != 17) {
             errors += "<p style='font-size: 12px;color: white;line-height: 12px'>VIN in incorrect format.</p> ";
             curr[0] = 2;
           }
           if (curr[5].length == 0 && curr[6].length == 0) {
             errors += "<p style='font-size: 12px;color: white;line-height: 12px'>Record must contain either mobile or home phone.</p> ";
             curr[0] = 2;
           }
           if (curr[5].length != 0 || curr[6].length != 0) {
             if (curr[5].length != 0) {
               if (!this.isValidPhone(curr[5])) {
                 errors += "<p style='font-size: 12px;color: white;line-height: 12px'>Mobile phone number format is incorrect. </p>";
                 curr[0] = 2;
               }
             }
             if (curr[6].length != 0) {
               if (!this.isValidPhone(curr[6])) {
                 errors += "<p style='font-size: 12px;color: white;line-height: 12px'>Home phone number format is incorrect </p>";
                 curr[0] = 2;
               }
             }
           }
           if (curr[7].length != 0) {
             if (!this.containsOnlyNumbers(curr[7])) {
               errors += "<p style='font-size: 12px;color: white;line-height: 12px'>Dealer code format is incorrect or the dealer code is invalid. </p> ";
               curr[0] = 2;
             }
           }
           if (curr[7].length != 0) {
             if (!this.checkDealerCode(curr[7])) {
               errors += "<p style='font-size: 12px;color: white;line-height: 12px'>You do not have access to the dealer code. </p> ";
               curr[0] = 2;
             }
           } else {
             errors += "<p style='font-size: 12px;color: white;line-height: 12px'>Dealer code cannot be empty </p>";
             curr[0] = 2;
           }
           if (this.chekIfVinHasUpdateDateSameAsCurrentDate(curr[1],result)) {
             errors += "<p style='font-size: 12px;color: white;line-height: 12px'>This VIN has already had one ownership update today and will \n" +
               "not be available to change ownership until tomorrow. Please use the Edit \n" +
               "Owner option to correct mistakes only. </p>";
             curr[0] = 2;
           }
           if(curr[9].length > 0){
             errors+=curr[9];
           }

           if (curr[0] == 0) {
             errors = "Processing. Please wait...";
           }
           var newEl = curr;
           newEl[9] = errors;
           let emptyFields = 0;
           for (var i of newEl) {
             if (i != undefined && i.length == 0) {
               emptyFields += 1;
             }
           }
           if (emptyFields < 4) {
             formattedData.push(newEl);
           }

         }

       }

       this.data = formattedData;
       this.getValidatedNumber(formattedData);
    });

  }

  /**
   * Check if file format is correct
   */
  checkFileFormat(file) {
    if (file.name.split(".")[1] == 'xlsx') {
      return true;
    }
    return false;
  }
  chekIfVinHasUpdateDateSameAsCurrentDate(vin,dbRecs){
    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth()+1;
    let yyyy = today.getFullYear();
    let date = yyyy+"-";
    if(mm<10){
      date+='0'+mm+"-";
    }else{
      date+=mm+"-";
    }
    if (dd<10){
      date+='0'+dd;
    }else{
      date+=dd;
    }
    let purchaseDate;
    for(let record of dbRecs){

      if(record[1]==vin){
        console.log((purchaseDate = record[8])+" : "+purchaseDate + " -> "+record[8] );
        if(record[8] != null && record[8] != undefined){
          purchaseDate = record[8];
        }
      }
    }
    if(purchaseDate == date){
      return true;
    }else{
      return false;
    }
  }

  filterDisplayItems(arr) {
    return arr.filter(x => arr.indexOf(x) < 8)
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.fileDropEl.nativeElement.value = "";
    this.uploadFilesSimulator(0);
  }

  resetForm() {
    this.step3 = false;
    this.finish = false;
    this.data = [];
    this.files = [];
    this.fileName="";
    this.fileLoaded=false;
    this.fileFormatError=false;
    this.fileLengthError=false;
  }

  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/owners/components/owner-bulk.component.ts